import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

import { reducerMapsList, reducerEditMapCenter } from "../../reducer/map/reducer/reducerMapsList";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const regionsCoordinates = [
  { id: 7, coords: [56.3269, 44.0075] },
  { id: 1, coords: [55.7522, 37.6156] },
  { id: 5, coords: [55.0084, 82.9357] },
  { id: 4, coords: [59.9343, 30.3351] },
  { id: 2, coords: [55.7522, 37.6156] },
  { id: 3, coords: [47.2357, 39.7015] }
];

export const actionGetMap = () => async (dispatch: AppDispatch, getState: () => any) => {
  const { token } = await getToken();
  axios.defaults.headers.common['Authorization'] = token;
  const store = getState();
  const defaultReportCenter = store.map.mapsList.defaultReportCenter;
  const inputValues = store.map.mapsList.inputValues;

  let monthOffset;
  if (inputValues.period.id === 'month') {
    monthOffset = 30;
  } else if (inputValues.period.id === 'threemonth') {
    monthOffset = 90;
  } else {
    monthOffset = 180;
  }

  const currentDate = new Date();
  const thirtyDaysAgo = new Date(currentDate.getTime() - (monthOffset * 24 * 60 * 60 * 1000));
  const firstDayFormatted = `${thirtyDaysAgo.getFullYear()}-${String(thirtyDaysAgo.getMonth() + 1).padStart(2, '0')}-${String(thirtyDaysAgo.getDate()).padStart(2, '0')}`;
  const lastDayFormatted = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;

  const filter = {
    ...inputValues,
    start: firstDayFormatted,
    end: lastDayFormatted,
    contract: inputValues.contract[0]
  };

  try {
    const response = await axios.post(
      `${BASE_URL}/json/pos/map`,
      filter
    );

    if (response.data) {
      dispatch(reducerMapsList(response.data));

      let newCenter = [55.7522, 37.6156];

      if (!defaultReportCenter && inputValues.regions && inputValues.regions.length > 0) {
        if (inputValues.regions.some((region: { id: number }) => region.id === 1)) {
          newCenter = [55.7522, 37.6156];
        } else if (response.data && response.data.length > 0) {
          newCenter = [response.data[0].longitude, response.data[0].latitude];
        } else {
          const foundRegion = regionsCoordinates.find(region => region.id === inputValues.regions[0].id);
          newCenter = foundRegion ? foundRegion.coords : newCenter;
        }
      } else if (defaultReportCenter) {
        newCenter = defaultReportCenter;
      }

      dispatch(reducerEditMapCenter(newCenter));
    } else {
      dispatch(reducerMapsList(null));
    }
    return response.data;
  } catch (e) {
    return e;
  }
};

export const actionGetUserReports =
  (id: number[], contract: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      try {
        const response = await axios.post(`${BASE_URL}/json/reports/list`, {
          limit: 1,
          page: 1,
          posIds: id,
          contracts: [contract]
        });
        return response.data.data[0];
      } catch (e: any) {
        console.log(e);
      }
    };
